import { render, staticRenderFns } from "./duplicate-client-warning-modal.vue?vue&type=template&id=011c4027"
import script from "./duplicate-client-warning-modal.vue?vue&type=script&lang=js"
export * from "./duplicate-client-warning-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports